<script>
import client from '@/client'

export default {
  name: 'PrivacyPolicy',

  mounted () {
    const url = client.client.privacyPolicyURL()
    window.location.replace(url)
  }
}
</script>
